import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const Stonehenge = {
  id: '23',
  name: 'Stonehenge',
  era: EraType.bronzeAge,
  icon: 'sh',
  gameId: 'Stonehenge',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.ANCIENT_WORLD,
  kind: WonderKind.STATUE | WonderKind.TEMPLE,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.GOLD_PRODUCTION_MOD,
      EffectAmount.asPerLevel([
        10,
        13,
        15,
        16.5,
        18,   // 5
        19.5,
        20.5,
        22.0,
        23.0,
        24.0, // 10
        24.5,
        25.5,
        26.5,
        27,
        28,   // 15
        28.5,
        29,
        30,
        30.5,
        31, // 20
        31.5,
        32.5,
        33,
        33.5,
        34,   // 25
        34.5,
        35,
        35.5,
        36,
        36.5  // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asCallbackWithLevel(
        function (level) {
          if (level >= 20) {
            return 3;
          }
          if (level >= 10) {
            return 2;
          }
          return 1;
        }
      ).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
  ]),
  synergies: [
    {
      effectIndex: 1,
      mod: Synergy.asFlat(1).withKind(WonderKind.TEMPLE),
      effect: null,
    }
  ],
};

export default Stonehenge;
